import * as React from 'react';
import classNames from 'classnames';

import { Slider } from '../../../../../../../../common/Slider';
import { SERVICES_SLIDER_ID } from '../../../../../../../../../constants/nodeIds';

import { getSliderIndents } from './utils';
import { ADDITIONAL_OFFSET, SLIDE_WIDTH, VISIBLE_SLIDES_COUNT } from './constants';
import * as styles from './ServicesSlider.css';

interface IProps {
  isMobile: boolean;
  isBetPositionVisible: boolean;
  activeServiceIndex: number | undefined;
  children: React.ReactNodeArray;
  disabled?: boolean;

  onScrollSliderRight(): void;

  onScrollSliderLeft(): void;
}

export const ServicesSlider = ({
  isMobile,
  isBetPositionVisible,
  activeServiceIndex,
  children,
  onScrollSliderLeft,
  onScrollSliderRight,
  disabled,
}: IProps) => {
  const indents = getSliderIndents({ isMobile, isBetPositionVisible });

  return (
    <div className={classNames(styles['services'], isMobile && styles['mobile'], disabled && styles['disabled'])}>
      <Slider
        id={SERVICES_SLIDER_ID}
        initialSlide={activeServiceIndex}
        indents={indents}
        slideWidth={SLIDE_WIDTH}
        additionalOffset={ADDITIONAL_OFFSET}
        visibleSlides={VISIBLE_SLIDES_COUNT}
        onScrollLeft={onScrollSliderLeft}
        onScrollRight={onScrollSliderRight}
      >
        {children}
      </Slider>
    </div>
  );
};
